import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.CakeDecorating;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "CakeDecorating.Phaser.IntroductionScene.1",
            "CakeDecorating.Phaser.IntroductionScene.2",
            "CakeDecorating.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/CakeDecorating/scenes/GameIntro.ts